// components
import Drawer from '@/components/Drawer';
import ContentViewer from '@/components/ContentViewer';
import JSONSchema from '@/modules/PromptDrawer/components/JSONSchema';
// utils
import useScriptDrawerStore from '@/modules/PromptDrawer/PromptDrawer.store.ts';

const PromptDrawer = () => {
    const { data, selectPrompt } = useScriptDrawerStore();

    return (
        <Drawer
            lockScroll={false}
            name="prompt-drawer"
            opened={!!data}
            position="left"
            size="md"
            title="Details"
            withOverlay={false}
            onClose={selectPrompt}
        >
            <div className="text-xs uppercase font-bold mt-10">Prompt:</div>
            <ContentViewer withCounter content={data?.prompt ?? ''} />

            {data?.schema ? (
                <>
                    <div className="text-xs uppercase font-bold mt-10">
                        Schema:
                    </div>
                    <div className="border border-solid border-gray-4 p-4 rounded-lg">
                        <JSONSchema value={data.schema} />
                    </div>
                </>
            ) : undefined}

            <div className="text-xs uppercase font-bold mt-10">Result</div>
            <ContentViewer
                className="bg-green-1"
                content={data?.result ?? ''}
            />
        </Drawer>
    );
};

export default PromptDrawer;
